import { Outlet, useParams } from "react-router-dom";
// import { useCallback } from "react";

// components
import CustomerInvoiceTabs from "./CustomerInvoiceTabs";
import ErrorDisplay from "../../components/ErrorDisplay";
import Loading from "../../components/Loading";
// functions
import { GenerateAllInvoiceDownload } from "../../funcs/invoicing/DownloadAllInvoices";
// global
import { projectStore } from "../../store/Store";
// styles and images
import "../project/Project.css";

// hooks
import useGetFetch from "../../hooks/useGetFetch";
// import MessageCard from "../../components/MessageCard";

export default function CustInvoices() {
  // global
  const currentProject = projectStore((data) => data.currentProject);
  const setCurrentProject = projectStore((data) => data.setCurrentProject);
  const projectCustomerInvoices = projectStore(
    (data) => data.projectCustomerInvoices,
  );
  const setProjectCustomerInvoices = projectStore(
    (data) => data.setProjectCustomerInvoices,
  );
  const setProjectCustomerInvoiceLoads = projectStore(
    (data) => data.setProjectCustomerInvoiceLoads,
  );
  const projectCustomerInvoiceLoads = projectStore(
    (data) => data.projectCustomerInvoiceLoads,
  );
  const setProjectCustomerInvoiceTotals = projectStore(
    (data) => data.setProjectCustomerInvoiceTotals,
  );
  const projectLoads = projectStore((data) => data.projectLoads);
  const setProjectLoads = projectStore((data) => data.setProjectLoads);
  const projectAssetLoads = projectStore((data) => data.projectAssetLoads);
  const setProjectAssetLoads = projectStore(
    (data) => data.setProjectAssetLoads,
  );
  const { invId } = useParams("invId");
  const { id } = useParams("id");

  const DownloadAllInvoices = () => {
    GenerateAllInvoiceDownload(
      projectLoads,
      projectAssetLoads,
      projectCustomerInvoices,
      projectCustomerInvoiceLoads,
      currentProject.project.job_name,
    );
  };
  const {
    isPending: projectPending,
    error: projectError,
    statusCode: projectCode,
  } = useGetFetch(
    `${process.env.REACT_APP_BACKEND}/pc/project/${id}`,
    setCurrentProject,
  );
  const {
    pending,
    error: invoicesError,
    statusCode,
  } = useGetFetch(
    `${process.env.REACT_APP_BACKEND}/pc/customer-invoices/${id}`,
    setProjectCustomerInvoices,
  );
  const {
    isPending: totalsPending,
    error: totalsError,
    statusCode: totalsCode,
  } = useGetFetch(
    `${process.env.REACT_APP_BACKEND}/pc/customer-invoices-totals/${id}`,
    setProjectCustomerInvoiceTotals,
  );
  const {
    isPending: invoiceLoadsPending,
    error: invoiceLoadsError,
    statusCode: invoiceLoadsCode,
  } = useGetFetch(
    `${process.env.REACT_APP_BACKEND}/pc/all-customer-invoice-loads/${id}`,
    setProjectCustomerInvoiceLoads,
  );
  const {
    isPending: loadsPending,
    error: loadsError,
    statusCode: loadsCode,
  } = useGetFetch(
    `${process.env.REACT_APP_BACKEND}/pc/loads/${id}`,
    setProjectLoads,
  );
  const {
    isPending: assetLoadsPending,
    error: assetLoadsError,
    statusCode: assetLoadsCode,
  } = useGetFetch(
    `${process.env.REACT_APP_BACKEND}/pc/asset-loads/${id}`,
    setProjectAssetLoads,
  );

  if (invoicesError) {
    return <ErrorDisplay message={invoicesError} code={statusCode} />;
  } else if (totalsError) {
    return <ErrorDisplay message={totalsError} code={totalsCode} />;
  } else if (loadsError) {
    return <ErrorDisplay message={loadsError} code={loadsCode} />;
  } else if (assetLoadsError) {
    return <ErrorDisplay message={assetLoadsError} code={assetLoadsCode} />;
  }
  if (invoiceLoadsError) {
    return <ErrorDisplay message={invoiceLoadsError} code={invoiceLoadsCode} />;
  } else if (projectError) {
    return <ErrorDisplay message={projectError} code={projectCode} />;
  } else {
    return !pending &&
      !totalsPending &&
      !loadsPending &&
      !projectPending &&
      !invoiceLoadsPending &&
      !assetLoadsPending ? (
      <div className="container-fluid">
        {totalsError && <p className="error">{totalsError}</p>}
        {!invId && (
          <div className="d-flex justify-content-between project-header border-bottom">
            <h4>Customer Invoices</h4>
            <div>
              {projectCustomerInvoices && projectLoads && (
                <button
                  className="btn btn-secondary"
                  style={{
                    margin: "10px",
                  }}
                  onClick={DownloadAllInvoices}
                >
                  Download All Invoices
                </button>
              )}
            </div>
          </div>
        )}
        {!invId ? (
          <CustomerInvoiceTabs />
        ) : (
          !invId && <p>No Invoices have been created for this project</p>
        )}
        <Outlet />
      </div>
    ) : (
      <Loading />
    );
  }
}
